'use client';
import { useConfig } from '@/app/contexts/ConfigContext';

type WithdrawalOnlyHeaderProps = {
  logoSrc: string;
  serviceName: string;
};

export default function WithdrawalOnlyHeader({
  logoSrc,
  serviceName,
}: WithdrawalOnlyHeaderProps) {
  const { config } = useConfig();

  return (
    <header
      className='relative z-20 flex h-20 w-full items-center justify-center bg-white px-3 shadow-lg 2xl:h-[120px] 2xl:px-[105px]'
      style={{ backgroundColor: config.theme.backgroundColor }}
    >
      <div className='flex min-h-[50px] items-center'>
        <img
          src={logoSrc}
          className='h-10 object-contain 2xl:h-12'
          alt={`${serviceName} logo`}
          fetchPriority='high'
        />
      </div>
    </header>
  );
}
